// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================
   PREMIUM CTA SECTION - SPOTLIGHT DESIGN
============================ */

.launch-section {
    padding: 140px 0;
    position: relative;
    overflow: hidden;
}

/* ============================
   ANIMATED BACKGROUND
============================ */

.launch-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    overflow: hidden;
}

.gradient-circle {
    position: absolute;
    border-radius: 50%;
    filter: blur(120px);
    opacity: 0.35;
    animation: float 25s ease-in-out infinite;
}

.circle-1 {
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, rgba(99, 102, 241, 0.6), transparent 70%);
    top: -25%;
    left: -15%;
    animation-delay: 0s;
}

.circle-2 {
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(168, 85, 247, 0.6), transparent 70%);
    top: -15%;
    right: -15%;
    animation-delay: 3s;
}

.circle-3 {
    width: 550px;
    height: 550px;
    background: radial-gradient(circle, rgba(236, 72, 153, 0.5), transparent 70%);
    bottom: -25%;
    left: 50%;
    transform: translateX(-50%);
    animation-delay: 6s;
}

@keyframes float {
    0%, 100% {
        transform: translate(0, 0) scale(1);
    }
    33% {
        transform: translate(40px, -40px) scale(1.15);
    }
    66% {
        transform: translate(-40px, 40px) scale(0.95);
    }
}

/* ============================
   CONTENT - SPOTLIGHT CARD
============================ */

.launch-content {
    position: relative;
    z-index: 10;
    text-align: center;
    max-width: 950px;
    margin: 0 auto;
    padding: 80px 50px;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.12), rgba(168, 85, 247, 0.08));
    border: 2px solid rgba(139, 92, 246, 0.4);
    border-radius: 32px;
    backdrop-filter: blur(20px);
    box-shadow: 
        0 30px 80px rgba(99, 102, 241, 0.3),
        0 0 0 1px rgba(255, 255, 255, 0.1) inset;
    animation: fadeInScale 1s ease-out;
    clip-path: polygon(
        0 20px, 20px 0,
        calc(100% - 20px) 0, 100% 20px,
        100% calc(100% - 20px), calc(100% - 20px) 100%,
        20px 100%, 0 calc(100% - 20px)
    );
}

@keyframes fadeInScale {
    from {
        opacity: 0;
        transform: scale(0.95);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

/* ============================
   BADGE
============================ */

.launch-badge {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 24px;
    background: rgba(99, 102, 241, 0.2);
    border: 2px solid rgba(139, 92, 246, 0.5);
    border-radius: 50px;
    color: #ffffff;
    font-size: 0.875rem;
    font-weight: 700;
    margin-bottom: 32px;
    animation: fadeInUp 0.6s ease-out 0.2s both;
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.3);
}

.launch-badge svg {
    color: #fbbf24;
    animation: rotate 4s linear infinite;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

/* ============================
   TITLE
============================ */

.launch-title {
    font-size: clamp(2.25rem, 5vw, 4rem);
    font-weight: 800;
    color: #ffffff;
    margin-bottom: 24px;
    line-height: 1.2;
    letter-spacing: -0.03em;
    animation: fadeInUp 0.6s ease-out 0.3s both;
    text-shadow: 0 4px 20px rgba(99, 102, 241, 0.4);
}

.highlight-text {
    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: relative;
    display: inline-block;
}

.highlight-text::after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(135deg, #6366f1, #a855f7, #ec4899);
    border-radius: 2px;
    animation: shimmer 2.5s ease-in-out infinite;
}

@keyframes shimmer {
    0%, 100% {
        opacity: 0.6;
        transform: scaleX(0.9);
    }
    50% {
        opacity: 1;
        transform: scaleX(1);
    }
}

/* ============================
   DESCRIPTION
============================ */

.launch-description {
    font-size: clamp(1.125rem, 2vw, 1.625rem);
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 48px;
    font-weight: 500;
    animation: fadeInUp 0.6s ease-out 0.4s both;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ============================
   FEATURES
============================ */

.launch-features {
    display: flex;
    justify-content: center;
    gap: 40px;
    flex-wrap: wrap;
    margin-bottom: 48px;
    animation: fadeInUp 0.6s ease-out 0.5s both;
}

.feature-item {
    display: flex;
    align-items: center;
    gap: 10px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 1rem;
    font-weight: 600;
}

.feature-item svg {
    color: #10b981;
    flex-shrink: 0;
    filter: drop-shadow(0 2px 6px rgba(16, 185, 129, 0.4));
}

/* ============================
   CTA BUTTON
============================ */

.launch-cta {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    padding: 20px 48px;
    background: linear-gradient(135deg, #6366f1, #a855f7);
    color: #ffffff;
    font-size: 1.1875rem;
    font-weight: 700;
    text-decoration: none;
    border-radius: 16px;
    border: none;
    box-shadow: 
        0 12px 45px rgba(99, 102, 241, 0.5),
        0 0 0 2px rgba(255, 255, 255, 0.15) inset;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    position: relative;
    overflow: hidden;
    animation: fadeInUp 0.6s ease-out 0.6s both;
}

/* Shine effect */
.launch-cta::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.6s ease;
}

.launch-cta:hover::before {
    left: 100%;
}

.launch-cta:hover {
    transform: translateY(-4px) scale(1.03);
    box-shadow: 
        0 18px 60px rgba(99, 102, 241, 0.6),
        0 0 0 3px rgba(255, 255, 255, 0.2) inset;
}

.launch-cta:active {
    transform: translateY(-2px) scale(1.01);
}

.launch-cta svg {
    transition: transform 0.3s ease;
}

.launch-cta:hover svg {
    transform: translateX(5px);
}

/* ============================
   RESPONSIVE
============================ */

@media (max-width: 768px) {
    .launch-section {
        padding: 100px 0;
    }

    .launch-content {
        padding: 60px 35px;
        border-radius: 24px;
        clip-path: polygon(
            0 15px, 15px 0,
            calc(100% - 15px) 0, 100% 15px,
            100% calc(100% - 15px), calc(100% - 15px) 100%,
            15px 100%, 0 calc(100% - 15px)
        );
    }

    .launch-features {
        flex-direction: column;
        gap: 20px;
        align-items: center;
    }

    .launch-cta {
        width: 100%;
        justify-content: center;
        font-size: 1.0625rem;
        padding: 18px 36px;
    }

    .gradient-circle {
        filter: blur(100px);
    }
}

@media (max-width: 480px) {
    .launch-content {
        padding: 50px 25px;
    }

    .launch-badge {
        font-size: 0.8125rem;
        padding: 8px 18px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/LaunchSection.css"],"names":[],"mappings":"AAAA;;8BAE8B;;AAE9B;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;8BAE8B;;AAE9B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6EAA6E;IAC7E,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6EAA6E;IAC7E,SAAS;IACT,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6EAA6E;IAC7E,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI;QACI,mCAAmC;IACvC;IACA;QACI,6CAA6C;IACjD;IACA;QACI,6CAA6C;IACjD;AACJ;;AAEA;;8BAE8B;;AAE9B;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,uFAAuF;IACvF,yCAAyC;IACzC,mBAAmB;IACnB,2BAA2B;IAC3B;;gDAE4C;IAC5C,kCAAkC;IAClC;;;;;KAKC;AACL;;AAEA;IACI;QACI,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;;8BAE8B;;AAE9B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mCAAmC;IACnC,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;8BAE8B;;AAE9B;IACI,oCAAoC;IACpC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,2CAA2C;IAC3C,+CAA+C;AACnD;;AAEA;IACI,8DAA8D;IAC9D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,WAAW;IACX,8DAA8D;IAC9D,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI;QACI,YAAY;QACZ,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,oBAAoB;IACxB;AACJ;;AAEA;;8BAE8B;;AAE9B;IACI,yCAAyC;IACzC,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;8BAE8B;;AAE9B;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,sDAAsD;AAC1D;;AAEA;;8BAE8B;;AAE9B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ;;iDAE6C;IAC7C,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uCAAuC;IACvC;;gDAE4C;AAChD;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;8BAE8B;;AAE9B;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;;;;;SAKC;IACL;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,uBAAuB;QACvB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;IACrB;AACJ","sourcesContent":["/* ============================\n   PREMIUM CTA SECTION - SPOTLIGHT DESIGN\n============================ */\n\n.launch-section {\n    padding: 140px 0;\n    position: relative;\n    overflow: hidden;\n}\n\n/* ============================\n   ANIMATED BACKGROUND\n============================ */\n\n.launch-background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 0;\n    overflow: hidden;\n}\n\n.gradient-circle {\n    position: absolute;\n    border-radius: 50%;\n    filter: blur(120px);\n    opacity: 0.35;\n    animation: float 25s ease-in-out infinite;\n}\n\n.circle-1 {\n    width: 600px;\n    height: 600px;\n    background: radial-gradient(circle, rgba(99, 102, 241, 0.6), transparent 70%);\n    top: -25%;\n    left: -15%;\n    animation-delay: 0s;\n}\n\n.circle-2 {\n    width: 500px;\n    height: 500px;\n    background: radial-gradient(circle, rgba(168, 85, 247, 0.6), transparent 70%);\n    top: -15%;\n    right: -15%;\n    animation-delay: 3s;\n}\n\n.circle-3 {\n    width: 550px;\n    height: 550px;\n    background: radial-gradient(circle, rgba(236, 72, 153, 0.5), transparent 70%);\n    bottom: -25%;\n    left: 50%;\n    transform: translateX(-50%);\n    animation-delay: 6s;\n}\n\n@keyframes float {\n    0%, 100% {\n        transform: translate(0, 0) scale(1);\n    }\n    33% {\n        transform: translate(40px, -40px) scale(1.15);\n    }\n    66% {\n        transform: translate(-40px, 40px) scale(0.95);\n    }\n}\n\n/* ============================\n   CONTENT - SPOTLIGHT CARD\n============================ */\n\n.launch-content {\n    position: relative;\n    z-index: 10;\n    text-align: center;\n    max-width: 950px;\n    margin: 0 auto;\n    padding: 80px 50px;\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.12), rgba(168, 85, 247, 0.08));\n    border: 2px solid rgba(139, 92, 246, 0.4);\n    border-radius: 32px;\n    backdrop-filter: blur(20px);\n    box-shadow: \n        0 30px 80px rgba(99, 102, 241, 0.3),\n        0 0 0 1px rgba(255, 255, 255, 0.1) inset;\n    animation: fadeInScale 1s ease-out;\n    clip-path: polygon(\n        0 20px, 20px 0,\n        calc(100% - 20px) 0, 100% 20px,\n        100% calc(100% - 20px), calc(100% - 20px) 100%,\n        20px 100%, 0 calc(100% - 20px)\n    );\n}\n\n@keyframes fadeInScale {\n    from {\n        opacity: 0;\n        transform: scale(0.95);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n/* ============================\n   BADGE\n============================ */\n\n.launch-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 24px;\n    background: rgba(99, 102, 241, 0.2);\n    border: 2px solid rgba(139, 92, 246, 0.5);\n    border-radius: 50px;\n    color: #ffffff;\n    font-size: 0.875rem;\n    font-weight: 700;\n    margin-bottom: 32px;\n    animation: fadeInUp 0.6s ease-out 0.2s both;\n    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.3);\n}\n\n.launch-badge svg {\n    color: #fbbf24;\n    animation: rotate 4s linear infinite;\n}\n\n@keyframes rotate {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* ============================\n   TITLE\n============================ */\n\n.launch-title {\n    font-size: clamp(2.25rem, 5vw, 4rem);\n    font-weight: 800;\n    color: #ffffff;\n    margin-bottom: 24px;\n    line-height: 1.2;\n    letter-spacing: -0.03em;\n    animation: fadeInUp 0.6s ease-out 0.3s both;\n    text-shadow: 0 4px 20px rgba(99, 102, 241, 0.4);\n}\n\n.highlight-text {\n    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    position: relative;\n    display: inline-block;\n}\n\n.highlight-text::after {\n    content: '';\n    position: absolute;\n    bottom: -6px;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: linear-gradient(135deg, #6366f1, #a855f7, #ec4899);\n    border-radius: 2px;\n    animation: shimmer 2.5s ease-in-out infinite;\n}\n\n@keyframes shimmer {\n    0%, 100% {\n        opacity: 0.6;\n        transform: scaleX(0.9);\n    }\n    50% {\n        opacity: 1;\n        transform: scaleX(1);\n    }\n}\n\n/* ============================\n   DESCRIPTION\n============================ */\n\n.launch-description {\n    font-size: clamp(1.125rem, 2vw, 1.625rem);\n    color: rgba(255, 255, 255, 0.85);\n    margin-bottom: 48px;\n    font-weight: 500;\n    animation: fadeInUp 0.6s ease-out 0.4s both;\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* ============================\n   FEATURES\n============================ */\n\n.launch-features {\n    display: flex;\n    justify-content: center;\n    gap: 40px;\n    flex-wrap: wrap;\n    margin-bottom: 48px;\n    animation: fadeInUp 0.6s ease-out 0.5s both;\n}\n\n.feature-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 1rem;\n    font-weight: 600;\n}\n\n.feature-item svg {\n    color: #10b981;\n    flex-shrink: 0;\n    filter: drop-shadow(0 2px 6px rgba(16, 185, 129, 0.4));\n}\n\n/* ============================\n   CTA BUTTON\n============================ */\n\n.launch-cta {\n    display: inline-flex;\n    align-items: center;\n    gap: 12px;\n    padding: 20px 48px;\n    background: linear-gradient(135deg, #6366f1, #a855f7);\n    color: #ffffff;\n    font-size: 1.1875rem;\n    font-weight: 700;\n    text-decoration: none;\n    border-radius: 16px;\n    border: none;\n    box-shadow: \n        0 12px 45px rgba(99, 102, 241, 0.5),\n        0 0 0 2px rgba(255, 255, 255, 0.15) inset;\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n    position: relative;\n    overflow: hidden;\n    animation: fadeInUp 0.6s ease-out 0.6s both;\n}\n\n/* Shine effect */\n.launch-cta::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n    transition: left 0.6s ease;\n}\n\n.launch-cta:hover::before {\n    left: 100%;\n}\n\n.launch-cta:hover {\n    transform: translateY(-4px) scale(1.03);\n    box-shadow: \n        0 18px 60px rgba(99, 102, 241, 0.6),\n        0 0 0 3px rgba(255, 255, 255, 0.2) inset;\n}\n\n.launch-cta:active {\n    transform: translateY(-2px) scale(1.01);\n}\n\n.launch-cta svg {\n    transition: transform 0.3s ease;\n}\n\n.launch-cta:hover svg {\n    transform: translateX(5px);\n}\n\n/* ============================\n   RESPONSIVE\n============================ */\n\n@media (max-width: 768px) {\n    .launch-section {\n        padding: 100px 0;\n    }\n\n    .launch-content {\n        padding: 60px 35px;\n        border-radius: 24px;\n        clip-path: polygon(\n            0 15px, 15px 0,\n            calc(100% - 15px) 0, 100% 15px,\n            100% calc(100% - 15px), calc(100% - 15px) 100%,\n            15px 100%, 0 calc(100% - 15px)\n        );\n    }\n\n    .launch-features {\n        flex-direction: column;\n        gap: 20px;\n        align-items: center;\n    }\n\n    .launch-cta {\n        width: 100%;\n        justify-content: center;\n        font-size: 1.0625rem;\n        padding: 18px 36px;\n    }\n\n    .gradient-circle {\n        filter: blur(100px);\n    }\n}\n\n@media (max-width: 480px) {\n    .launch-content {\n        padding: 50px 25px;\n    }\n\n    .launch-badge {\n        font-size: 0.8125rem;\n        padding: 8px 18px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
